module.exports = __webpack_public_path__ + "img/Krag_Lyrikken_vender_tilbake2.f5f3ac59.jpg";